import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { StyleClass } from 'primeng/styleclass';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth/auth.service';
import { ProfileStateService } from '@app/core/services/profile-state.service';
import { BillingStateService } from '@app/core/services/billing-state.service';

@Component({
  selector: 'app-user-action-menu',
  imports: [StyleClass, AsyncPipe, RouterLink],
  templateUrl: './user-action-menu.component.html',
  styleUrl: './user-action-menu.component.scss',
})
export class UserActionMenuComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private authService = inject(AuthService);
  profileStateService = inject(ProfileStateService);
  // The Billing link shows only for a workshop that is billed (billing is null otherwise).
  billingState = inject(BillingStateService);

  username: string | null = null;
  isTenantAdmin = false;
  isLoading = true;
  error = '';

  avatarUrl$ = this.profileStateService.avatarUrl;
  initials$ = this.profileStateService.initials;
  name$ = this.profileStateService.name;

  private destroy$ = new Subject<void>();

  async ngOnInit(): Promise<void> {
    await this.loadUserDetails();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async onSignOut(): Promise<void> {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }

  navigateToTenantInformation(): void {
    this.router.navigate(['/app/tenant-information']);
  }

  navigateToBilling(): void {
    this.router.navigate(['/app/billing']);
  }

  navigateToProfile(): void {
    this.router.navigate(['/app/profile']);
  }

  private async loadUserDetails(): Promise<void> {
    try {
      this.isLoading = true;
      this.error = '';
      this.username = await this.authService.getUsername();
      const role = await this.authService.getUserRole();
      this.isTenantAdmin = role === 'tenant_admin' || role === 'system_admin';
    } catch (error) {
      console.error('Error loading user details:', error);
      await this.router.navigate(['/auth/login']);
    } finally {
      this.isLoading = false;
    }
  }
}
